import React from 'react';

export const Spinner = () => (
    <div className="spinner-component"></div>
);